<template>
  <div class="seomain">
    <st-header
      title="库存台账"
      :back-able="true"
			:more-op="[{val: 'openShowSearch', title: '搜索' },{ val: 'download', title: '下载' }]"
			@command="headercommand"
    >
    </st-header>

    <!-- <div class="keyword">
      <van-search
        v-model="scode"
        shape="round"
        show-action
        background="#e0e0e0"
        placeholder="请输入单号搜索"
        @search="onSearch"
        @cancel="onCancel"
      />
    </div> -->
		
    <div class="tab-content tab-content-list">
			<div class="keyword">
        <div class="keyword-panel" v-if="showSearch">
          <div class="keyword-panel-head">
            <span class="keyword-panel-title">搜索筛选</span>
            <span class="keyword-panel-close" @click="showSearch = false">
              <van-icon name="cross" />
            </span>
          </div>
          <van-form class="keyword-form" @submit="submitKeyword">
            <van-field v-model="searchData.order_code" label="单号" placeholder="请输入单号" />
            <van-field v-model="searchData.sku" label="SKU" placeholder="SKU" />
            <div class="search-type-wrap">
              <div
                :class="['type-item', activeSearchType == 1 ? 'active' : '']"
                @click="selectSearchTypeHandle(1)"
              >业务类型<van-icon name="play" /></div>
              <div
                :class="['type-item', activeSearchType == 2 ? 'active' : '']"
                @click="selectSearchTypeHandle(2)"
              >仓库<van-icon name="play" /></div>
              <div
                :class="['type-item', activeSearchType == 3 ? 'active' : '']"
                @click="selectSearchTypeHandle(3)"
              >发生时间<van-icon name="play" /></div>
            </div>

            <div class="search-list-wrap" v-if="activeSearchType != 0">
              <van-grid :column-num="3" :border="false" gutter="10" v-show="activeSearchType == 1">
                <van-grid-item
                  :class="['grid-item', item.selected ? 'active' : '']"
                  v-for="item in typeSearchList"
                  :key="item.value"
                  :text="item.text"
                  @click="item.selected = !item.selected"
                />
              </van-grid>
              <van-grid :column-num="3" :border="false" gutter="10" v-show="activeSearchType == 2">
                <van-grid-item
                  :class="['grid-item', item.selected ? 'active' : '']"
                  v-for="item in warehouseSearchList"
                  :key="item.id"
                  :text="item.name"
                  @click="item.selected = !item.selected"
                />
              </van-grid>
              <van-row class="stock-input-wrap" type="flex" justify="space-around" v-show="activeSearchType == 3">
                <van-col span="10" class="min-input-wrap">
                  <st-date v-model="stockSearch.minimum" placeholder="请选择开始日期" date-type="date"></st-date>
                </van-col>
                <van-col span="1"><van-divider :style="{ borderColor: '#e5e5e5' }"/></van-col>
                <van-col span="10" class="max-input-wrap">
                  <st-date v-model="stockSearch.maximum" placeholder="请选择结束日期" date-type="date"></st-date>
                </van-col>
              </van-row>
            </div>

            <div class="keyword-form-actions keyword-form-actions-split">
              <button class="clearBtn" type="button" @click="clearSearch">清空条件</button>
              <button class="submitBtn" type="submit">搜 索</button>
            </div>
          </van-form>
        </div>
        <div class="keyword-collapsed" v-else @click="showSearch = true">
          <div class="keyword-collapsed-inner">
            <van-icon name="search" />
            <span>搜索单号 / SKU</span>
          </div>
        </div>
			</div>
			
			
			
      <div class="st-list-box pan-3">
				<van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
				  <div class="st-list" v-for="(v, k) in stlist" :key="v.id" :index="k">
				    <div class="st-list-top st-list-top-with-qty">
							<div class="t-tit">{{ v.psku || v.sku || '--' }}</div>
              <div class="t-qty">{{ v.quantity }}</div>
				    </div>
				    <div class="st-list-main">
              <div class="st-field"><span class="st-field-label">单据日期</span><span class="st-field-value">{{ v.createtime_text || '--' }}</span></div>
              <div class="st-field"><span class="st-field-label">单据类型</span><span class="st-field-value">{{ v.divergence_text }}单</span></div>
              <div class="st-field"><span class="st-field-label">单据编号</span><span class="st-field-value">{{ v.ordercode || '--' }}</span></div>
              <div class="st-field"><span class="st-field-label">业务类型</span><span class="st-field-value">{{ orderTypeMap[v.type] || '--' }}</span></div>
              <div class="st-field"><span class="st-field-label">往来单位</span><span class="st-field-value">{{ v.supplier_name || '--' }}</span></div>
              <div class="st-field"><span class="st-field-label">SKU</span><span class="st-field-value">{{ v.psku || '--' }}</span></div>
              <div class="st-field"><span class="st-field-label">产品名称</span><span class="st-field-value">{{ v.pname || '--' }}</span></div>
              <div class="st-field"><span class="st-field-label">历史SKU</span><span class="st-field-value">{{ v.sku || '--' }}</span></div>
              <div class="st-field"><span class="st-field-label">仓库</span><span class="st-field-value">{{ (v.warehouse && v.warehouse.name) || '--' }}</span></div>
              <div class="st-field"><span class="st-field-label">子仓库</span><span class="st-field-value">{{ v.child_warehouse || '--' }}</span></div>
              <div class="st-field"><span class="st-field-label">仓位</span><span class="st-field-value">{{ v.position || '--' }}</span></div>
              <div class="st-field"><span class="st-field-label">EP货源</span><span class="st-field-value">{{ v.isep == 1 ? 'EP货源' : '非EP货源' }}</span></div>
              <div class="st-field"><span class="st-field-label">收入</span><span class="st-field-value">{{ v.divergence == 1 ? v.quantity : '-' }}</span></div>
              <div class="st-field"><span class="st-field-label">支出</span><span class="st-field-value">{{ v.divergence == 0 ? v.quantity : '-' }}</span></div>
              <div class="st-field"><span class="st-field-label">结存</span><span class="st-field-value">{{ v.after }}</span></div>
				    </div>
					</div>
				</van-list>
			</div>
      
		</div>

  </div>
</template>

<script>
import StHeader from "@/components/layout/Header.vue";
import StDate from "@/components/Date.vue";
export default {
  components: {
    "st-header": StHeader,
		StDate,
  },
  props: {},
	inject: ['reload'],
  data() {
    return {
      loading: false,
      finished: false,
      page: 1,
			type: 0,
			
			searchData: {},
			showSearch: false,
			
			activeSearchType: 0,
			typeSearchList: [],
			warehouseSearchList: [],
			stockSearch: {
				minimum: '',
				maximum: ''
			},
			
      stlist: [],
      scode: "", // 关键字搜索
			orderTypeMap: {},
    };
  },
  computed: {},
  methods: {
		init() {
			this.$option['inventorylog_type'].forEach(v => {
				this.orderTypeMap[v.value] = v.text;
			});
			
			this.typeSearchList = this.$option['inventorylog_type'].map((v) => { v.selected = false; return v; });
			
			this.$post(this.$api.stWarehouse, {'page_size': '10000'}).then((res) => {
				let data = res.data.list;
				// 仓库数据
				this.warehouseSearchList = data.filter((item) => {
					item.selected = false;
					return item;
				});
			});
			
		},
		// 更多里的操作
		headercommand(val) {
			this[val]();
		},
		
		onCancel() {},
		openShowSearch() {
			this.showSearch = true;
		},
		/**
		 * 下载付款单
		 */
		async download() {
			let params = {
				type: this.typeSearchList.map((v) => {return v.selected ? v.value : false; }).filter((v) => {return v;}).join(','),
				warehouse_id: !this.warehouseSearchList ? "" : this.warehouseSearchList.map((v) => {return v.selected ? v.value : false; }).filter((v) => {return v;}).join(','),
				createtime: this.stockSearch,
				page: this.page,
				...this.searchData
			}
			
			await this.$post(this.$api.stInventoryLogDownload, params).then((res) => {
				window.location.href = res.data;
			})
			
		},
		
		/**
		 * 清空搜索条件
		 */
		clearSearch() {
		  // console.log("清空搜索条件");
		  this.typeSearchList = this.typeSearchList.filter((item) => {
		    item.selected = false;
		    return item;
		  });
		  this.warehouseSearchList = this.warehouseSearchList.filter((item) => {
		    item.selected = false;
		    return item;
		  });
		  this.stockSearch = { minimum: "", maximum: "" };
			
			this.$forceUpdate();
		  this.$toast("已清空搜索条件");
		},
   

    // 分页
    async onLoad() {
			this.loading = true;
			let params = {
				type: this.typeSearchList.map((v) => {return v.selected ? v.value : false; }).filter((v) => {return v;}).join(','),
				warehouse_id: !this.warehouseSearchList ? "" : this.warehouseSearchList.map((v) => {return v.selected ? v.id : false; }).filter((v) => {return v;}).join(','),
				createtime: this.stockSearch,
				page: this.page,
				...this.searchData
			}
			
      let result = await this.$post(this.$api.stInventoryLogList, params);
      if (result.data.list.length == 0) return (this.finished = true);
      // 进行操作
      this.stlist.push(...result.data.list);
      // 操作完成
      this.page += 1;
      this.loading = false;
    },
		selectSearchTypeHandle(value) {
			if (this.activeSearchType === value) return (this.activeSearchType = 0);
			this.activeSearchType = value;
		},
    submitKeyword() {
			this.activeSearchType = 0;
      this.stlist= [];
      this.finished = false;
      this.page = 1;
      this.onLoad();
    },

  },
  created() {
    this.init();
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
$green: #00baad;
$gray: #677588;
div {
	box-sizing: border-box;
}
.search-icon-span .van-icon {
	font-size: 24px!important;
	color: #1a89fa;
	margin: 8px 12px;
	font-weight: 900;
}

.search-type-wrap {
  display: flex;
  padding: 12px 12px 0;
  gap: 8px;
  .type-item {
    flex: 1;
    height: 36px;
    border-radius: 18px;
    background: #f5f7fb;
    color: #757877;
    display: flex;
    align-items: center;
    justify-content: center;
    .van-icon {
      margin-left: 6px;
      transform: rotate(90deg);
      transition: transform 0.5s;
    }

    &.active {
      color: $green;
      background: #e8f7f1;
      .van-icon {
        transform: rotate(-90deg);
      }
    }
  }
}

.search-list-wrap {
		padding-top: 20px;

		.grid-item {
			margin: 3px 0;
			color: #757877;

			::v-deep .van-grid-item__content {
				padding: 4px 0;
				background-color: #f1f1f1;
			}

			&.active {
				color: #3dae7d;
				::v-deep .van-grid-item__content {
					background-color: #d9f3e6;
				}
			}
		}

		.stock-input-wrap {
			.min-input-wrap,
			.max-input-wrap {
				background-color: #eaeaea;
				border-radius: 2px;
				overflow: hidden;

				input {
					padding-left: 12px;
					width: 100%;
					height: 100%;
					border: none;
					background-color: transparent;
					outline: none;
				}
				input::placeholder {
					color: #a6a6a6;
				}
			}
		}

		.search-submit-wrap {
			.clearBtn {
				width: 154px;
				height: 35px;
				color: #fff;
				border: none;
				border-radius: 5px;
				background-color: $gray;
				outline: none;
			}
			.submitBtn {
				width: 154px;
				height: 35px;
				color: #fff;
				border: none;
				border-radius: 5px;
				background-color: $green;
				outline: none;
			}
		}
	}


.keyword {
  position: relative;
  width: 100%;
  z-index: 1;
  background-color: transparent;
  padding-top: 0;
  padding-bottom: 8px;
  margin-top: 40px;
  margin-bottom: 0;
}

.keyword-panel {
  margin: 0 12px;
  border-radius: 10px;
  background: #fff;
  border: 1px solid #eceff5;
  overflow: hidden;
}

.keyword-panel-head {
  height: 40px;
  padding: 0 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #f0f2f7;
}

.keyword-panel-title {
  font-size: 14px;
  color: #5c6575;
  font-weight: 600;
}

.keyword-panel-close {
  color: #8a93a3;
  font-size: 18px;
  line-height: 1;
}

.keyword-form {
  margin: 0;
}

.keyword-form-actions {
  padding: 12px;
  background-color: #fff;
}

.keyword-form-actions-split {
  display: flex;
  gap: 12px;
}

.keyword-collapsed {
  margin: 0 12px;
  height: 40px;
  border-radius: 10px;
  background: #fff;
  color: #8b95a7;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #eceff5;
  box-shadow: none;
}

.keyword-collapsed-inner {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  white-space: nowrap;
  line-height: 1;
}

.keyword-collapsed-inner .van-icon {
  flex: 0 0 auto;
  font-size: 14px;
}

.keyword-collapsed-inner span {
  flex: 0 0 auto;
  font-size: 14px;
}

.tab-content-list {
	padding-top: 0px;
	position: relative;
	top: 0px;
}
.st-list-box{
	margin: 12px 24px 10px;
	.st-list {
		border-radius: 5px;
	}
}
.st-header-right {
  .el-icon-circle-plus {
    font-size: 30px;
    transform: translateY(7px);
    color: rgba(42, 130, 228, 1);
  }
}

.st-list-bottom-xs {
  border-radius: 5px;
  font-size: 14px;
}

.four li {
  width: 25%;
}
.st-list-bottom-xs {
  background: #677588;
}
.pan-2 .t-tit {
  border-left: 3px solid #43cf7c;
}
.pan-3 .t-tit {
  border-left: 3px solid #ff5733;
}

.st-list-bottom-2,.st-list-bottom-3 {
	background-color: white;
	display: flex;
	flex-wrap: wrap;
	justify-content: space-between;
	width: 100%;
}

.st-list-bottom-2 {
	.van-button {
		margin-top: 8px;
		width: 45%;
		border-radius: 8px;
	}
}

.st-list-bottom-3 {
	.van-button {
		width: 30%;
		border-radius: 8px;
	}
}

.st-list-bottom-diy {
  display: flex;
}
.st-list-bottom-diy .st-diyl-btn {
  background: #677588;
  border-radius: 5px;
  flex: 1;
  margin-right: 8px;
}
.st-list-bottom-diy .st-diyr-btn {
  background: #00baad;
  border-radius: 5px;
  flex: 1;
  margin-left: 8px;
}

.st-list-main {
	position: relative;
  padding-top: 4px;
  padding-bottom: 4px;
  .st-field {
    display: flex;
    align-items: flex-start;
    padding: 6px 0;
    font-size: 14px;
    line-height: 1.5;
    border-bottom: 1px dashed #f1f3f7;
  }
  .st-field:last-child {
    border-bottom: 0;
    padding-bottom: 0;
  }
  .st-field-label {
    flex: 0 0 90px;
    color: #7d8697;
  }
  .st-field-label::after {
    content: "：";
  }
  .st-field-value {
    flex: 1;
    min-width: 0;
    color: #394150;
    word-break: break-all;
  }
	.list-checkbox {
		position: absolute;
		top: 10px;
		right: 20px;
	}
}
</style>
<style lang="scss" scoped>
.tab-tilte.four {
  display: flex;
}
.tab-tilte.four .text-center {
  flex: 1;
}
.st-list-top-with-qty {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}
.st-list-top-with-qty .t-tit {
  flex: 1;
  min-width: 0;
}
.t-qty {
  flex: 0 0 auto;
  color: #2a82e4;
  font-size: 20px;
  font-weight: 700;
}
.st-btn-3 {
	width: 30%;
	height: 50%;
	border-radius: 5px;
}
</style>
